import axios from "axios";
import { API_URL, PUB_URL, PUB_API_URL, PUB_API_URL_FLEET } from "./constants";

const headers = {
  Authorization: `${localStorage.getItem("token")}`,
};

export const GET_PROFILE_API = async () =>
  await axios.get(`${API_URL}/company-infos`, { headers });
export const GET_COUNTRIES_API = async () =>
  await axios.get(`${PUB_URL}/countries?multiDriver=true`);
export const GET_MANAGMENT_API = async (body) =>
  await axios.post(`${API_URL}/performances`, body, { headers });
export const GET_DRIVERS_API = async () =>
  await axios.get(`${API_URL}/drivers`, { headers });
export const GET_VEHICLES_API = async () =>
  await axios.get(`${API_URL}/vehicles`, { headers });
export const GET_TRIPS_API = async (filters) =>
  await axios.get(`${API_URL}/trips`, { headers, params: filters });

export const GET_DRIVERS_BALANCE_API = async (filters) =>
  await axios.get(`${API_URL}/fleet-balance`, { headers, params: filters });
export const GET_FLEET_BALANCE_API = async () =>
  await axios.get(`${API_URL}/total-balance`, { headers });

export const GET_DRIVERS_REVENUES_API = async (filters) =>
  await axios.get(`${API_URL}/drivers-earning-list`, {
    headers,
    params: filters,
  });
export const GET_FLEET_REVENUES_API = async (filters) =>
  await axios.get(`${API_URL}/total-drivers-earning`, { headers, params: filters });

export const GET_TRIP_API = async (id) =>
  await axios.get(`${API_URL}/trips/${id}`, { headers });
export const GET_LEVELPATH_API = async (body) =>
  await axios.post(`${PUB_API_URL}/public/sublevels`, body);
export const GET_MODELS_API = async (body) =>
  await axios.post(`${PUB_API_URL_FLEET}/models`, body, { headers });
export const GET_EARNINGS_API = async (body) =>
  await axios.post(`${API_URL}/earnings`, body, { headers });
export const POST_DRIVER_API = async (body) =>
  await axios.post(`${PUB_API_URL_FLEET}/driver`, body, { headers });
export const POST_VEHICLE_API = async (body) =>
  await axios.post(`${PUB_API_URL_FLEET}/vehicle`, body, { headers });
export const GET_DRIVER_API = async (idDriver) =>
  await axios.get(`${PUB_API_URL_FLEET}/${idDriver}/details`, { headers });
export const PUT_AFFECT_CAR_API = async (body) =>
  await axios.put(`${PUB_API_URL_FLEET}/affect-car`, body, { headers });
export const DELETE_CAR_API = async (vehicleId) =>
  await axios.delete(`${PUB_API_URL_FLEET}/delete-car/${vehicleId}`, {
    headers,
  });

export const REQUEST_DELETE_API = async (driverId) =>
  await axios.put(`${PUB_API_URL_FLEET}/${driverId}/request-delete`, driverId, {
    headers,
  });
export const GET_PAYMENTS_API = async (body) =>
  await axios.post(`${API_URL}/company-payment`, body, { headers });
export const GET_VEHICLE_API = async (vehicleId) =>
  await axios.get(`${API_URL}/vehicle/${vehicleId}`, { headers });
export const EDIT_VEHICLE_API = async (body, vehicleId) =>
  await axios.put(`${API_URL}/vehicle/${vehicleId}`, body, { headers });
export const EDIT_DRIVER_API = async (body, driverId) =>
  await axios.put(`${API_URL}/driver/${driverId}`, body, { headers });
export const PUT_RETRACT_CAR_API = async (body) =>
  await axios.put(`${PUB_API_URL_FLEET}/retract-car`, body, { headers });
export const GET_LIST_METHOD_PAYMENT_API = async () =>
  await axios({
    method: "post",
    url: `${API_URL}/epay/methods/v2/all`,
    headers,
  });
export const POST_PAY_COMMISSION_API = async (body) =>
  await axios.post(`${API_URL}/epay/payment/pay`, body, { headers });
export const POST_CHECK_PAY_API = async (body) =>
  await axios.post(`${API_URL}/epay/payment/check`, body, { headers });

export const GET_DRIVERS = async (body) =>
  await axios.post(`${PUB_API_URL_FLEET}/drivers/map`, body, {
    headers,
  });

// export const GET_LIST_METHOD_PAYMENT_API = async () => await axios.get(`${API_URL}/epay/methods/v2/all`, { headers });
export const GET_SERVICES = async () =>
  await axios.get(`${PUB_API_URL_FLEET}/services`, {
    headers,
  });

export const GET_DRIVERS_MAP = async (body) =>
  await axios.post(`${PUB_API_URL_FLEET}/drivers/map`, body, {
    headers,
  });

export const GET_DRIVER_DOCUMENTS = async (driverId) =>
  await axios.get(`${PUB_API_URL_FLEET}/driver/${driverId}/documents`, {
    headers,
  });

export const SUBMIT_DRIVER_DOCUMENTS = async (driverId, body) =>
  await axios.post(
    `${PUB_API_URL_FLEET}/driver/${driverId}/upload-documents`,
    body,
    {
      headers,
    }
  );
